var $6f40c3a58f594b58$exports = {};
const $6f40c3a58f594b58$var$addBtnRef = document.getElementById("addBookmarkBtn");
const $6f40c3a58f594b58$var$bookmarksListRef = document.querySelector("#bookmarkList");
const $6f40c3a58f594b58$var$inputRef = document.querySelector("#bookmarkInput");
const $6f40c3a58f594b58$var$STORAGE_KEY = "listOfBookmarks";
let $6f40c3a58f594b58$var$arrayOfBookmarks = [];
const $6f40c3a58f594b58$var$saved = JSON.parse(localStorage.getItem($6f40c3a58f594b58$var$STORAGE_KEY)) || [];
$6f40c3a58f594b58$var$arrayOfBookmarks = $6f40c3a58f594b58$var$saved;
$6f40c3a58f594b58$var$createItems($6f40c3a58f594b58$var$arrayOfBookmarks);
function $6f40c3a58f594b58$var$createItems(array) {
    const items = array.map((item)=>{
        return `<li>
  <a href="${item}" target="_blank">${item}</a>
  <button type="button" class="delete">X</button>
</li>`;
    }).join("");
    $6f40c3a58f594b58$var$bookmarksListRef.innerHTML = items;
}
$6f40c3a58f594b58$var$addBtnRef.addEventListener("click", ()=>{
    $6f40c3a58f594b58$var$arrayOfBookmarks.push($6f40c3a58f594b58$var$inputRef.value);
    $6f40c3a58f594b58$var$inputRef.value = "";
    $6f40c3a58f594b58$var$createItems($6f40c3a58f594b58$var$arrayOfBookmarks);
    localStorage.setItem($6f40c3a58f594b58$var$STORAGE_KEY, JSON.stringify($6f40c3a58f594b58$var$arrayOfBookmarks));
});
$6f40c3a58f594b58$var$bookmarksListRef.addEventListener("click", (e)=>{
    if (e.target.classList.contains("delete")) {
        const li = e.target.parentElement;
        const value = li.querySelector("a").textContent;
        $6f40c3a58f594b58$var$arrayOfBookmarks = $6f40c3a58f594b58$var$arrayOfBookmarks.filter((item)=>item !== value);
        li.remove();
        localStorage.setItem($6f40c3a58f594b58$var$STORAGE_KEY, JSON.stringify($6f40c3a58f594b58$var$arrayOfBookmarks));
    }
});


//# sourceMappingURL=json-hw.f3a71d88.js.map
